<template>
    <div class="block-editor tsoft-select-order">
        <section v-if="!channel">
            <a-result status="warning" title="T-Soft API not connected">
                <template #extra>
                    <div class="d-flex align-items-center justify-content-center">
                        <SupsisButton primary ghost @click="gotoTsoft"> Connect to T-Soft</SupsisButton>
                    </div>
                </template>
            </a-result>
        </section>
        <template v-else>
            <section class="active-connection">
                <div data-small="true" class="logos">
                    <div class="logo1">
                        <img class="custom-block-logo" src="/static/img/supsis-logo2.png" />
                    </div>
                    <span class="material-icons"> add </span>
                    <div class="logo2">
                        <TsoftIcon style="width:30px;height:30px" />
                    </div>
                </div>
                <div class="active-connection-text">
                    <div><span>Connected with</span> <b>T-Soft</b></div>
                </div>
            </section>
            <div class="tsoft-select-order-wrapper">
                <div class="inputTitle">T-Soft Müşteri Email Veya Telefon Numarası</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor
                        v-model="clone.customerEmail"
                        :show-attributes="true"
                        :max-character-count="64"
                        :show-emoji="false"
                        placeholder="Müşteri Email Adresi Veya Telefon Numarası"
                        :rows="1"
                    />
                </div>
                <div class="mt-4">
                    <a-alert type="info" show-icon>
                        <div slot="message">
                            <div class="font-weight-bold">Bilgi</div>
                            <div>
                                Bu blok, müşteri email adresini kullanarak T-Soft'tan sipariş bilgilerini alır ve
                                müşterinin seçim yapabilmesi için siparişleri listeler. Müşteri, siparişler
                                arasından birini seçtikten sonra, seçilen siparişin bilgileri attribute'lara
                                kaydedilir ve success bloğuna yönlendirilir.
                            </div>
                        </div>
                    </a-alert>
                </div>
            </div>
            <div class="inputTitle mt-5 mb-2 font-weight-bold">{{ $t("chatbotv2.followingAttributesFilled") }}</div>
            <section class="next-step-filled-items-wrapper">
                <div class="logos middle-section" v-for="attr in nextStepFilledValue" :key="attr">
                    <AttributeIconPreview :attribute="attr" />
                    <span class="ml-2">
                        <AttributeLabel :attribute="attr" />
                    </span>
                </div>
            </section>
        </template>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import TiptapEditor from "../../common/TiptapEditor";
import AttributeLabel from "../../common/tiptap-extensions/AttributeLabel";
import AttributeIconPreview from "../../common/AttributeIconPreview";
import _ from "lodash";
import { mapState } from "vuex";
import SupsisButton from "../../../../../Settings/components/SupsisButton.vue";
import TsoftIcon from "../../../integrations/svg/TsoftIcon.vue";

const log = log2("TsoftSelectOrder");
export default {
    name: "TsoftSelectOrder",
    components: { TsoftIcon, SupsisButton, TiptapEditor, AttributeLabel, AttributeIconPreview },
    props: {
        value: {
            type: Object,
            default: () => ({ customerEmail: "{{tsoft_customer_email}}" }),
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            nextStepFilledValue: [
                "tsoft_order_id",
                "tsoft_order_number",
                "tsoft_invoice_url",
                "tsoft_order_status",
                "tsoft_order_price",
                "tsoft_shipper_name",
                "tsoft_order_date",
                "tsoft_track_number",
                "tsoft_track_url",
                "tsoft_currency",
            ],
        };
    },
    computed: {
        ...mapState({
            channel: (state) => state.channel.channels.find((x) => x.type === "t-soft"),
        }),
    },
    methods: {
        gotoTsoft() {
            this.$router.push("/integrations/t-soft");
        },
    },
    mounted() {
        log("mounted");
    },
    watch: {
        clone: {
            handler(val) {
                log("clone changed", val);
                this.$emit("input", val);
            },
            deep: true,
        },
        value(val) {
            if (_.isEqual(val, this.clone)) {
                return;
            }
            this.clone = _.cloneDeep(val);
        },
    },
};
</script>

<style lang="scss">
.block-editor.tsoft-select-order {
    padding: 30px 30px 0;

    .active-connection {
        align-items: center;
        background: #fff;
        border-radius: 6px;
        display: flex;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 20px;
        overflow: hidden;
        padding: 20px;
        width: 100%;
        word-break: break-word;

        .logos {
            align-items: center;
            display: flex;
            flex-shrink: 0;
            margin-right: 15px;
            margin-top: 4px;

            .logo1 {
                background: #4a6586;
            }

            .logo2 {
                background: #fff;
            }

            .logo1,
            .logo2 {
                height: 30px;
                padding: 4px;
                width: 30px;
            }
        }

        .filled-attributes {
            margin: 0px 0px -17px -50px !important;
        }
    }

    .next-step-filled-items-wrapper {
        background: #fff;
        border-radius: 6px;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 20px;
        padding: 20px;
        width: 100%;

        .middle-section {
            background: #ffdc66;
            cursor: pointer;
            transition: all 0.3s;
            border-radius: 10px;
            box-decoration-break: clone;
            display: flex;
            justify-content: center;
            padding: 5px;
            width: fit-content;
            margin: 5px;
            align-items: center;
            font-weight: 800;
        }
    }

    .active-connection-text {
        flex-grow: 1;
        flex-shrink: 0;
        width: 0;

        div {
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: pre-wrap;
        }
    }

    .tsoft-select-order-wrapper {
        .inputTitle {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .editable-editor {
            p {
                margin-bottom: 0;
            }
        }
    }
}
</style>
